const freeShippingCountries = new Set(["US","CA","AT","BE","BG","CY","CZ","DE","DK","EE","ES","FI","FR","GB","GR","HR","HU","IE","IT","LT","LU","LV","MT","NL","PL","PT","RO","SE","SI","SK","CH","NO","AU","NZ","KR","JP","HK","MO","BN","ID","KH","LA","MM","MY","PH","SG","TH","TL","VN","AE","SA","KW","QA","BH","TW","MX","OM"]);

class VertaroCartShippingNote extends HTMLElement {
  connectedCallback() {
    this.shippingObserver?.disconnect();
    this.shippingObserver = new MutationObserver(() => this.updateShippingNote());
    this.shippingObserver.observe(this, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-country'],
    });
    this.updateShippingNote();
  }

  disconnectedCallback() {
    this.shippingObserver?.disconnect();
  }

  updateShippingNote() {
    if (!this.isConnected) return;
    const original = this.querySelector('[data-shipping-original]');
    const free = this.querySelector('[data-shipping-free]');
    if (!original || !free) return;
    const text = original.textContent.trim();
    const pattern = /Shipping is calculated at checkout\.?/i;
    const isFree = freeShippingCountries.has(this.dataset.country) && pattern.test(text);

    if (isFree) {
      const freeText = text.replace(pattern, 'Free shipping.');
      if (free.textContent !== freeText) free.textContent = freeText;
    }
    original.hidden = isFree;
    free.hidden = !isFree;
  }
}

if (!customElements.get('vertaro-cart-shipping-note')) {
  customElements.define('vertaro-cart-shipping-note', VertaroCartShippingNote);
}
